import { axios } from '..';
export interface ICouncil {
  id?: string;
  ContactId: string;
  Region: number;
  IsChair: boolean;
  IsChairEmeritus: boolean;
  isActive: boolean;
}

export const getCouncils = async (): Promise<ICouncil[]> => {
  try {
    const response = await axios.Get('/council');
    return response.data;
  } catch (error) {
    console.error('Error fetching Councils:', error);
    return [];
  }
};

export const getCouncilById = async (id: string): Promise<ICouncil> => {
  try {
    const params = new URLSearchParams();
    params.append('filter', JSON.stringify({id: {value: id, comparisonType: 'EQUAL'}}));
    const response = await axios.Get(`/council?${params.toString()}`);
    return response.data[0];
  } catch (error) {
    console.error("Error fetching Council:", error);
    throw error;
  }
};

export const getCouncilByContactId = async (contactId: string): Promise<ICouncil> => {
  try {
    const params = new URLSearchParams();
    params.append('filter', JSON.stringify({ContactId: {value: contactId, comparisonType: 'EQUAL'}}));
    const response = await axios.Get(`/council?${params.toString()}`);
    return response.data[0];
  } catch (error) {
    console.error("Error fetching Council by ContactId:", error);
    throw error;
  }
};

export const addCouncil = async (council: ICouncil): Promise<ICouncil> => {
  try {
    const response = await axios.Post('council', council);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateCouncil = async (council: ICouncil): Promise<ICouncil> => {
  try {
    const response = await axios.Put('council', council);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteCouncil = async (councilId: string) => {
  try {
    await axios.Delete('council', councilId);
    return true;
  } catch (error) {
    throw error;
  }
};

export const getActiveCouncils = async (): Promise<ICouncil[]> => {
  try {
    const params = new URLSearchParams();
    params.append('filter', JSON.stringify({isActive: {value: true, comparisonType: 'EQUAL'}}));
    const response = await axios.Get(`/council?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching active Councils:', error);
    return [];
  }
};

export const getCouncilsByRegion = async (region: string): Promise<ICouncil[]> => {
  try {
    const params = new URLSearchParams();
    params.append('filter', JSON.stringify({Region: {value: region, comparisonType: 'EQUAL'}}));
    const response = await axios.Get(`/council?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching Councils by region:', error);
    return [];
  }
};

export const getChairs = async (): Promise<ICouncil[]> => {
  try {
    const params = new URLSearchParams();
    params.append('filter', JSON.stringify({IsChair: {value: true, comparisonType: 'EQUAL'}}));
    const response = await axios.Get(`/council?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching chairs:', error);
    return [];
  }
};

export const getChairEmeritus = async (): Promise<ICouncil[]> => {
  try {
    const params = new URLSearchParams();
    params.append('filter', JSON.stringify({IsChairEmeritus: {value: true, comparisonType: 'EQUAL'}}));
    const response = await axios.Get(`/council?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching chair emeritus:', error);
    return [];
  }
};
